<template>
  <img class="skillset-horizon" :src="require('@/assets/skillset-horizon.png')">

  <div class="flex h-screen relative items-center justify-center skillset-template section-background relative">
    <div class="skillset-inner max-w-xlg">
      <img class="skillset-gem-1" :src="require('@/assets/skillset-gem-1.png')">
      <img class="skillset-gem-2" :src="require('@/assets/skillset-gem-2.png')">
      <img class="skillset-gem-3" :src="require('@/assets/skillset-gem-3.png')">
      <img class="skillset-gem-4" :src="require('@/assets/skillset-gem-4.png')">
      <h2 class="text-5xl mb-12">{{headerEmphasis}} <span>{{headerItalic}}</span></h2>
      <div class="skillset-gfx-holder">
        <img class="skillset-gfx-img" :src="skillsetImages[0].image">
        <div class="skillset-gfx-inner">
          <h2>{{innerHeader}}</h2>
          <p class="whitespace-pre-line">{{innerParagraph}}</p>
        </div>
        <div class="skillset-side">
          <div class="skillset-side-button">
            <span class="shadow-md float-left p-4 bg-white rounded-full flex items-center justify-center inline">
              <svg class="text-lime w-8 h-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#88c100" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"/></svg>
            </span>
            <span class="shadow-md float-left p-4 bg-white rounded-full flex items-center justify-center inline">
              <svg class="text-lime w-8 h-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#88c100" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"/></svg>
            </span>
            <span class="shadow-md float-left p-4 bg-white rounded-full flex items-center justify-center inline">
              <svg class="text-lime w-8 h-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#88c100" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"/></svg>
            </span>
          </div>
        </div>

        <img class="skillset-decor" :src="require('@/assets/skillset-decor.png')">

<!--         <div v-for="(image, index) in skillsetTools" :key="index" :class="[`index--${index}`]">
           {{index}} <img :class="[`fruit-${index}`]" :src="image.image">
        </div> -->

        <div class="skillset-tools st-top">
          <div class="skillset-tool">
            <img :src="require('@/assets/skillset-tool-2.png')">
            <span class="shadow-md float-left p-4 bg-white rounded-full flex items-center justify-center inline">
                <svg class="text-lime w-8 h-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="#88c100" d="M14 95.7924C14 42.8877 56.8878 0 109.793 0H274.161C327.066 0 369.954 42.8877 369.954 95.7924C369.954 129.292 352.758 158.776 326.711 175.897C352.758 193.019 369.954 222.502 369.954 256.002C369.954 308.907 327.066 351.795 274.161 351.795H272.081C247.279 351.795 224.678 342.369 207.666 326.904V415.167C207.666 468.777 163.657 512 110.309 512C57.5361 512 14 469.243 14 416.207C14 382.709 31.1945 353.227 57.2392 336.105C31.1945 318.983 14 289.5 14 256.002C14 222.502 31.196 193.019 57.2425 175.897C31.196 158.776 14 129.292 14 95.7924ZM176.288 191.587H109.793C74.2172 191.587 45.3778 220.427 45.3778 256.002C45.3778 291.44 73.9948 320.194 109.381 320.416C109.518 320.415 109.655 320.415 109.793 320.415H176.288V191.587ZM207.666 256.002C207.666 291.577 236.505 320.417 272.081 320.417H274.161C309.737 320.417 338.576 291.577 338.576 256.002C338.576 220.427 309.737 191.587 274.161 191.587H272.081C236.505 191.587 207.666 220.427 207.666 256.002ZM109.793 351.795C109.655 351.795 109.518 351.794 109.381 351.794C73.9948 352.015 45.3778 380.769 45.3778 416.207C45.3778 451.652 74.6025 480.622 110.309 480.622C146.591 480.622 176.288 451.186 176.288 415.167V351.795H109.793ZM109.793 31.3778C74.2172 31.3778 45.3778 60.2173 45.3778 95.7924C45.3778 131.368 74.2172 160.207 109.793 160.207H176.288V31.3778H109.793ZM207.666 160.207H274.161C309.737 160.207 338.576 131.368 338.576 95.7924C338.576 60.2173 309.737 31.3778 274.161 31.3778H207.666V160.207Z"/></svg>
            </span>
          </div>
          &nbsp;
          <div class="skillset-tool">
            <img :src="require('@/assets/skillset-tool-2.png')">
            <span class="shadow-md float-left p-4 bg-white rounded-full flex items-center justify-center inline">
                <svg class="text-lime w-8 h-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="#88c100" d="M0 32l34.9 395.8L191.5 480l157.6-52.2L384 32H0zm308.2 127.9H124.4l4.1 49.4h175.6l-13.6 148.4-97.9 27v.3h-1.1l-98.7-27.3-6-75.8h47.7L138 320l53.5 14.5 53.7-14.5 6-62.2H84.3L71.5 112.2h241.1l-4.4 47.7z"/></svg>
            </span>
          </div>
          &nbsp;
          <div class="skillset-tool">
            <img :src="require('@/assets/skillset-tool-2.png')">
            <span class="shadow-md float-left p-4 bg-white rounded-full flex items-center justify-center inline">
                <svg class="text-lime w-8 h-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="#88c100" d="M0 32l34.9 395.8L192 480l157.1-52.2L384 32H0zm313.1 80l-4.8 47.3L193 208.6l-.3.1h111.5l-12.8 146.6-98.2 28.7-98.8-29.2-6.4-73.9h48.9l3.2 38.3 52.6 13.3 54.7-15.4 3.7-61.6-166.3-.5v-.1l-.2.1-3.6-46.3L193.1 162l6.5-2.7H76.7L70.9 112h242.2z"/></svg>
            </span>
          </div>
          &nbsp;
          <div class="skillset-tool">
            <img :src="require('@/assets/skillset-tool-2.png')">
            <span class="shadow-md float-left p-4 bg-white rounded-full flex items-center justify-center inline">
                <svg class="text-lime w-8 h-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#88c100" d="M0 32v448h448V32H0zm243.8 349.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z"/></svg>
            </span>
          </div>
          &nbsp;
          <div class="skillset-tool">
            <img :src="require('@/assets/skillset-tool-2.png')">
            <span class="shadow-md float-left p-4 bg-white rounded-full flex items-center justify-center inline">
                <svg class="text-lime w-8 h-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path fill="#88c100" d="M301.84 378.92c-.3.6-.6 1.08 0 0zm249.13-87a131.16 131.16 0 0 0-58 13.5c-5.9-11.9-12-22.3-13-30.1-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.3-6.7-24 2.5-25.29 5.9a122.83 122.83 0 0 0-5.3 19.1c-2.3 11.7-25.79 53.5-39.09 75.3-4.4-8.5-8.1-16-8.9-22-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.29-6.7-24 2.5-25.3 5.9-2.7 11.4-5.3 19.1-33.89 77.3-42.08 95.4c-4.2 9.2-7.8 16.6-10.4 21.6-.4.8-.7 1.3-.9 1.7.3-.5.5-1 .5-.8-2.2 4.3-3.5 6.7-3.5 6.7v.1c-1.7 3.2-3.6 6.1-4.5 6.1-.6 0-1.9-8.4.3-19.9 4.7-24.2 15.8-61.8 15.7-63.1-.1-.7 2.1-7.2-7.3-10.7-9.1-3.3-12.4 2.2-13.2 2.2s-1.4 2-1.4 2 10.1-42.4-19.39-42.4c-18.4 0-44 20.2-56.58 38.5-7.9 4.3-25 13.6-43 23.5-6.9 3.8-14 7.7-20.7 11.4-.5-.5-.9-1-1.4-1.5-35.79-38.2-101.87-65.2-99.07-116.5 1-18.7 7.5-67.8 127.07-127.4 98-48.8 176.35-35.4 189.84-5.6 19.4 42.5-41.89 121.6-143.66 133-38.79 4.3-59.18-10.7-64.28-16.3-5.3-5.9-6.1-6.2-8.1-5.1-3.3 1.8-1.2 7 0 10.1 3 7.9 15.5 21.9 36.79 28.9 18.7 6.1 64.18 9.5 119.17-11.8 61.78-23.8 109.87-90.1 95.77-145.6C386.52 18.32 293-.18 204.57 31.22c-52.69 18.7-109.67 48.1-150.66 86.4-48.69 45.6-56.48 85.3-53.28 101.9 11.39 58.9 92.57 97.3 125.06 125.7-1.6.9-3.1 1.7-4.5 2.5-16.29 8.1-78.18 40.5-93.67 74.7-17.5 38.8 2.9 66.6 16.29 70.4 41.79 11.6 84.58-9.3 107.57-43.6s20.2-79.1 9.6-99.5c-.1-.3-.3-.5-.4-.8 4.2-2.5 8.5-5 12.8-7.5 8.29-4.9 16.39-9.4 23.49-13.3-4 10.8-6.9 23.8-8.4 42.6-1.8 22 7.3 50.5 19.1 61.7 5.2 4.9 11.49 5 15.39 5 13.8 0 20-11.4 26.89-25 8.5-16.6 16-35.9 16-35.9s-9.4 52.2 16.3 52.2c9.39 0 18.79-12.1 23-18.3v.1s.2-.4.7-1.2c1-1.5 1.5-2.4 1.5-2.4v-.3c3.8-6.5 12.1-21.4 24.59-46 16.2-31.8 31.69-71.5 31.69-71.5a201.24 201.24 0 0 0 6.2 25.8c2.8 9.5 8.7 19.9 13.4 30-3.8 5.2-6.1 8.2-6.1 8.2a.31.31 0 0 0 .1.2c-3 4-6.4 8.3-9.9 12.5-12.79 15.2-28 32.6-30 37.6-2.4 5.9-1.8 10.3 2.8 13.7 3.4 2.6 9.4 3 15.69 2.5 11.5-.8 19.6-3.6 23.5-5.4a82.2 82.2 0 0 0 20.19-10.6c12.5-9.2 20.1-22.4 19.4-39.8-.4-9.6-3.5-19.2-7.3-28.2 1.1-1.6 2.3-3.3 3.4-5C434.8 301.72 450.1 270 450.1 270a201.24 201.24 0 0 0 6.2 25.8c2.4 8.1 7.09 17 11.39 25.7-18.59 15.1-30.09 32.6-34.09 44.1-7.4 21.3-1.6 30.9 9.3 33.1 4.9 1 11.9-1.3 17.1-3.5a79.46 79.46 0 0 0 21.59-11.1c12.5-9.2 24.59-22.1 23.79-39.6-.3-7.9-2.5-15.8-5.4-23.4 15.7-6.6 36.09-10.2 62.09-7.2 55.68 6.5 66.58 41.3 64.48 55.8s-13.8 22.6-17.7 25-5.1 3.3-4.8 5.1c.5 2.6 2.3 2.5 5.6 1.9 4.6-.8 29.19-11.8 30.29-38.7 1.6-34-31.09-71.4-89-71.1zm-429.18 144.7c-18.39 20.1-44.19 27.7-55.28 21.3C54.61 451 59.31 421.42 82 400c13.8-13 31.59-25 43.39-32.4 2.7-1.6 6.6-4 11.4-6.9.8-.5 1.2-.7 1.2-.7.9-.6 1.9-1.1 2.9-1.7 8.29 30.4.3 57.2-19.1 78.3zm134.36-91.4c-6.4 15.7-19.89 55.7-28.09 53.6-7-1.8-11.3-32.3-1.4-62.3 5-15.1 15.6-33.1 21.9-40.1 10.09-11.3 21.19-14.9 23.79-10.4 3.5 5.9-12.2 49.4-16.2 59.2zm111 53c-2.7 1.4-5.2 2.3-6.4 1.6-.9-.5 1.1-2.4 1.1-2.4s13.9-14.9 19.4-21.7c3.2-4 6.9-8.7 10.89-13.9 0 .5.1 1 .1 1.6-.13 17.9-17.32 30-25.12 34.8zm85.58-19.5c-2-1.4-1.7-6.1 5-20.7 2.6-5.7 8.59-15.3 19-24.5a36.18 36.18 0 0 1 1.9 10.8c-.1 22.5-16.2 30.9-25.89 34.4z"/></svg>
            </span>
          </div>
          <span class="stretch"></span>
        </div>
        <div class="skillset-tools">
          <div class="skillset-tool">
            <img :src="require('@/assets/skillset-tool-2.png')">
            <span class="shadow-md float-left p-4 bg-white rounded-full flex items-center justify-center inline">
                <p class="text-lime w-8 h-8">Xd</p>
            </span>
          </div>
          &nbsp;
          <div class="skillset-tool">
            <img :src="require('@/assets/skillset-tool-2.png')">
            <span class="shadow-md float-left p-4 bg-white rounded-full flex items-center justify-center inline">
                <p class="text-lime w-8 h-8">Ps</p>
            </span>
          </div>
          &nbsp;
          <div class="skillset-tool">
            <img :src="require('@/assets/skillset-tool-2.png')">
            <span class="shadow-md float-left p-4 bg-white rounded-full flex items-center justify-center inline">
                <svg class="text-lime w-8 h-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#88c100" d="M400 32H48A48 48 0 0 0 0 80V432a48 48 0 0 0 48 48H400a48 48 0 0 0 48-48V80A48 48 0 0 0 400 32ZM336 312c-31.6 11.2-41.2 16-59.8 16-31.4 0-43.2-16-74.6-16a80 80 0 0 0-25.6 4V284a85.9 85.9 0 0 1 25.6-4c31.2 0 43.2 16 74.6 16 10.2 0 17.8-1.4 27.8-4.6v-96c-10 3.2-17.6 4.6-27.8 4.6-31.4 0-43.2-16-74.6-16-25.4 0-37.4 10.4-57.6 14.4V352a16 16 0 0 1-32 0V160a16 16 0 0 1 32 0v6.4c20.2-4 32.2-14.4 57.6-14.4 31.2 0 43.2 16 74.6 16 18.6 0 28.2-4.8 59.8-16Z"/></svg>
            </span>
          </div>
          &nbsp;
          <div class="skillset-tool">
            <img :src="require('@/assets/skillset-tool-2.png')">
            <span class="shadow-md float-left p-4 bg-white rounded-full flex items-center justify-center inline">
                <svg class="text-lime w-8 h-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="#88c100" d="M333.5,201.4c0-22.1-15.6-34.3-43-34.3h-50.4v71.2h42.5C315.4,238.2,333.5,225,333.5,201.4z M517,188.6 c-9.5-30.9-10.9-68.8-9.8-98.1c1.1-30.5-22.7-58.5-54.7-58.5H123.7c-32.1,0-55.8,28.1-54.7,58.5c1,29.3-0.3,67.2-9.8,98.1 c-9.6,31-25.7,50.6-52.2,53.1v28.5c26.4,2.5,42.6,22.1,52.2,53.1c9.5,30.9,10.9,68.8,9.8,98.1c-1.1,30.5,22.7,58.5,54.7,58.5h328.7 c32.1,0,55.8-28.1,54.7-58.5c-1-29.3,0.3-67.2,9.8-98.1c9.6-31,25.7-50.6,52.1-53.1v-28.5C542.7,239.2,526.5,219.6,517,188.6z M300.2,375.1h-97.9V136.8h97.4c43.3,0,71.7,23.4,71.7,59.4c0,25.3-19.1,47.9-43.5,51.8v1.3c33.2,3.6,55.5,26.6,55.5,58.3 C383.4,349.7,352.1,375.1,300.2,375.1z M290.2,266.4h-50.1v78.4h52.3c34.2,0,52.3-13.7,52.3-39.5 C344.7,279.6,326.1,266.4,290.2,266.4z"/></svg>
            </span>
          </div>
          &nbsp;
          <div class="skillset-tool">
            <img :src="require('@/assets/skillset-tool-2.png')">
            <span class="shadow-md float-left p-4 bg-white rounded-full flex items-center justify-center inline">
                <svg class="text-lime w-8 h-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#88c100" d="M356.9 64.3H280l-56 88.6-48-88.6H0L224 448 448 64.3h-91.1zm-301.2 32h53.8L224 294.5 338.4 96.3h53.8L224 384.5 55.7 96.3z"/></svg>
            </span>
          </div>
          <span class="stretch"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headerEmphasis: "Technology",
      headerItalic:"& Tools",
      innerHeader: "Shane Gunnell - UI/UX Designer",
      innerParagraph: "Having worked in both design and development, we've picked up a large knowledge base of various tools and tech. \n\n Not every project requires every tool, but the more tools one knows, the more extensive one's capabilities become. ",
      skillsetImages: [
        {image: require("@/assets/skillset-gfx-2.png")},
      ],
      skillsetTools: [
        {image: require("@/assets/skillset-gfx.png")},{image: require("@/assets/skillset-gfx.png")},{image: require("@/assets/skillset-gfx.png")},{image: require("@/assets/skillset-gfx.png")}
      ],
    }
  }
}
</script>

<style>
.skillset-horizon {
  width: 100%;
}
.skillset-template {
  width: 100%;
  overflow: hidden;
  background: #F9F9F9;
}

.skillset-gfx-img {
  z-index: 1;
  position: relative;
  filter: drop-shadow(0px 0px 15px #e1e1e1);
}
.skillset-gfx-holder {
  max-width: 955px;
  position: relative;
}
.skillset-gfx-inner {
  width: 437px;
  text-align: left;
  position: absolute;
  top: 42px;
  left: 370px;
  z-index: 1;
}

.skillset-gfx-inner h2 {
  color: #373737;
  font-size: 25px;
  text-shadow: 0 3px 6px #00000021;
  margin-bottom: 15px;
}

.skillset-gfx-inner p {
  font-size: 14px;
  color: #828282;
}

.skillset-side {
  position: absolute;
  top: 56px;
  right: 33px;
  z-index: 1;
}

.skillset-side-button {
  width: 52px;
}

.skillset-side-button span {
  margin-bottom: 20px;
}

.skillset-side-button span svg {
  width: 20px;
  height: 20px;
}

.skillset-gem-1 {
  position: absolute;
  top: 0;
  left: 0;
}

.skillset-gem-2 {
  position: absolute;
  top: 0;
  right: 50px;
}

.skillset-gem-3 {
  position: absolute;
  bottom: 250px;
  right: -10px;
}

.skillset-gem-4 {
  position: absolute;
  bottom: 0;
  left: 50px;
}

.skillset-gem-5 {
  position: absolute;
  bottom: -260px;
  left: 45%;
}

.skillset-decor {
  position: absolute;
  top: 331px;
  right: 64px;
  width: 818px;
}

.skillset-tool {
  display: inline-block;
  position: relative;
  padding: 8px;
  filter: drop-shadow(0px 0px 5px #999);
  vertical-align: top;
}

.skillset-tool span {
  position: absolute;
  top: 48px;
  left: 47px;
}

.skillset-tool p {
  font-size: 21px;
  text-align: center;
}

.skillset-tools {
    text-align: justify;
    -ms-text-justify: distribute-all-lines;
    text-justify: distribute-all-lines;
}

.st-top {
  margin-top: 90px;
}

.stretch {
    width: 100%;
    display: inline-block;
    font-size: 0;
    line-height: 0
}

@media screen and (max-width: 992px) {
  .skillset-gfx-img, .skillset-gfx-inner, .skillset-side, .skillset-decor {
    display: none;
  }
  .skillset-tool {
    max-width: 110px;
  }
  .skillset-tool span {
    top: 31px;
    left: 31px;
    padding: 8px;
  }
  .skillset-tools .stretch {
    display: none;
  }
  .skillset-gem-1 {
    left: -200px;
  }
  .skillset-gem-2 {
    right: -80px;
  }
  .skillset-gem-4, .skillset-gem-3 {
    display: none;
  }
  .skillset-template {
    padding-top: 100px;
    padding-bottom: 100px;
  }
}

</style>
